import actions from "./actions";

const {
  EMPLOYEE_DISCOUNT_MODEL_LIST_BEGIN,
  EMPLOYEE_DISCOUNT_MODEL_LIST_SUCCESS,
  EMPLOYEE_DISCOUNT_MODEL_LIST_ERR,
  EMPLOYEE_DISCOUNT_MODEL_LIST_RESET,
  EMPLOYEE_DISCOUNT_CHECK_BEGIN,
  EMPLOYEE_DISCOUNT_CHECK_SUCCESS,
  EMPLOYEE_DISCOUNT_CHECK_ERR,
  EMPLOYEE_DISCOUNT_CHECK_RESET,
  EMPLOYEE_DISCOUNT_WALLET_BALANCE_BEGIN,
  EMPLOYEE_DISCOUNT_WALLET_BALANCE_SUCCESS,
  EMPLOYEE_DISCOUNT_WALLET_BALANCE_ERR,
  EMPLOYEE_DISCOUNT_SUBMIT_BEGIN,
  EMPLOYEE_DISCOUNT_SUBMIT_SUCCESS,
  EMPLOYEE_DISCOUNT_SUBMIT_ERR,
  EMPLOYEE_DISCOUNT_SUBMIT_RESET,
  EMPLOYEE_DISCOUNT_HISTORY_BEGIN,
  EMPLOYEE_DISCOUNT_HISTORY_SUCCESS,
  EMPLOYEE_DISCOUNT_HISTORY_ERR,
  EMPLOYEE_DISCOUNT_HISTORY_RESET,
  EMPLOYEE_DISCOUNT_HISTORY_DETAILS_BEGIN,
  EMPLOYEE_DISCOUNT_HISTORY_DETAILS_SUCCESS,
  EMPLOYEE_DISCOUNT_HISTORY_DETAILS_ERR,
  EMPLOYEE_DISCOUNT_HISTORY_DETAILS_RESET,
  EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_BEGIN,
  EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_SUCCESS,
  EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_ERR,
} = actions;

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const employeeDiscountModelListReducer = (
  state = initialState,
  action
) => {
  const { type, data, err } = action;

  switch (type) {
    case EMPLOYEE_DISCOUNT_MODEL_LIST_BEGIN:
      return { ...initialState, loading: true };

    case EMPLOYEE_DISCOUNT_MODEL_LIST_SUCCESS:
      return { ...initialState, data, loading: false };

    case EMPLOYEE_DISCOUNT_MODEL_LIST_ERR:
      return { ...initialState, error: err, loading: false };

    case EMPLOYEE_DISCOUNT_MODEL_LIST_RESET:
      return initialState;

    default:
      return state;
  }
};

export const employeeDiscountCheckReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case EMPLOYEE_DISCOUNT_CHECK_BEGIN:
      return { ...initialState, loading: true };

    case EMPLOYEE_DISCOUNT_CHECK_SUCCESS:
      return { ...initialState, data, loading: false };

    case EMPLOYEE_DISCOUNT_CHECK_ERR:
      return { ...initialState, error: err, loading: false };

    case EMPLOYEE_DISCOUNT_CHECK_RESET:
      return initialState;

    default:
      return state;
  }
};

export const employeeDiscountWalletReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case EMPLOYEE_DISCOUNT_WALLET_BALANCE_BEGIN:
      return { ...initialState, loading: true };

    case EMPLOYEE_DISCOUNT_WALLET_BALANCE_SUCCESS:
      return { ...initialState, data, loading: false };

    case EMPLOYEE_DISCOUNT_WALLET_BALANCE_ERR:
      return { ...initialState, error: err, loading: false };

    default:
      return state;
  }
};

export const employeeDiscountSubmitReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case EMPLOYEE_DISCOUNT_SUBMIT_BEGIN:
      return { ...initialState, loading: true };

    case EMPLOYEE_DISCOUNT_SUBMIT_SUCCESS:
      return { ...initialState, data, loading: false };

    case EMPLOYEE_DISCOUNT_SUBMIT_ERR:
      return { ...initialState, error: err, loading: false };

    case EMPLOYEE_DISCOUNT_SUBMIT_RESET:
      return initialState;

    default:
      return state;
  }
};

export const employeeDiscountHistoryReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case EMPLOYEE_DISCOUNT_HISTORY_BEGIN:
      return { ...initialState, loading: true };

    case EMPLOYEE_DISCOUNT_HISTORY_SUCCESS:
      return { ...initialState, data, loading: false };

    case EMPLOYEE_DISCOUNT_HISTORY_ERR:
      return { ...initialState, error: err, loading: false };

    case EMPLOYEE_DISCOUNT_HISTORY_RESET:
      return initialState;

    default:
      return state;
  }
};

export const employeeDiscountHistoryDetailsReducer = (
  state = initialState,
  action
) => {
  const { type, data, err } = action;

  switch (type) {
    case EMPLOYEE_DISCOUNT_HISTORY_DETAILS_BEGIN:
      return { ...initialState, loading: true };

    case EMPLOYEE_DISCOUNT_HISTORY_DETAILS_SUCCESS:
      return { ...initialState, data, loading: false };

    case EMPLOYEE_DISCOUNT_HISTORY_DETAILS_ERR:
      return { ...initialState, error: err, loading: false };

    case EMPLOYEE_DISCOUNT_HISTORY_DETAILS_RESET:
      return initialState;

    default:
      return state;
  }
};

export const employeeDiscountPurchaseHistoryReducer = (
  state = initialState,
  action
) => {
  const { type, data, err } = action;

  switch (type) {
    case EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_BEGIN:
      return { ...initialState, loading: true };

    case EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_SUCCESS:
      return { ...initialState, data, loading: false };

    case EMPLOYEE_DISCOUNT_PURCHASE_HISTORY_ERR:
      return { ...initialState, error: err, loading: false };

    default:
      return state;
  }
};
